const Credenciamento = () => {
  return window.location.replace(
    'https://sigevent.pro/merkator/visitantes/formularios.php?id_edicao=304'
  );
};

export default Credenciamento;
